import * as React from 'react';

import { cn } from '@shared/utils/lib/ui';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  children?: React.ReactNode;
}

function Skeleton({ className, children, loading = true, ...props }: SkeletonProps) {
  if (!loading) {
    return <>{children}</>;
  }

  if (children) {
    return (
      <span className={cn('relative inline-block', className)}>
        <span className='absolute inset-0 animate-pulse rounded-md bg-accent' {...props} />
        <span className='invisible'>{children}</span>
      </span>
    );
  }

  return <div className={cn('animate-pulse rounded-md bg-accent', className)} {...props} />;
}

export { Skeleton };
